module.exports = __webpack_public_path__ + "img/overview.c41f75f6.jpg";